module.exports = __webpack_public_path__ + "img/g4.f19649ad.png";